export default __webpack_public_path__ + "static/media/cold-brew.c0c5dd69.png";